import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type DummySearchBarProps = {
    placeholder: string
    onPress?: () => void
} & TestID

const DummySearchBar: FunctionComponent<DummySearchBarProps> = ({
    placeholder,
    onPress,
    testID,
}): ReactElement => {
    return (
        <Touchable onPress={onPress} activeOpacity={1}>
            <Grid noExpand horizontal testID={testID} backgroundColor="TRANSPARENT">
                <Grid
                    horizontal
                    backgroundColor="moon-2"
                    centerVertical
                    borderRadius={18}
                    height={36}
                    paddingRight={5}
                    minWidth={0}
                >
                    <Grid noExpand marginLeft={5} marginRight={3}>
                        <FontelloIcon name="search" color="keshi-4" fontSize={16} />
                    </Grid>
                    <Grid minWidth={0}>
                        <Grid noExpand marginTop={1}>
                            <SmallBodyFont color="keshi-4" numberOfLines={1}>
                                {placeholder}
                            </SmallBodyFont>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Touchable>
    )
}

export default DummySearchBar
